import { render, staticRenderFns } from "./CreditPaymentTerms.vue?vue&type=template&id=632cfbdd"
import script from "./CreditPaymentTerms.vue?vue&type=script&lang=js"
export * from "./CreditPaymentTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports